var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var BackgroundSize = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(BackgroundSize, _Declaration);

  var _super = _createSuper(BackgroundSize);

  function BackgroundSize() {
    _classCallCheck(this, BackgroundSize);

    return _super.apply(this, arguments);
  }

  _createClass(BackgroundSize, [{
    key: "set",
    value:
    /**
     * Duplication parameter for -webkit- browsers
     */
    function set(decl, prefix) {
      var value = decl.value.toLowerCase();

      if (prefix === '-webkit-' && !value.includes(' ') && value !== 'contain' && value !== 'cover') {
        decl.value = decl.value + ' ' + decl.value;
      }

      return _get(_getPrototypeOf(BackgroundSize.prototype), "set", this).call(this, decl, prefix);
    }
  }]);

  return BackgroundSize;
}(Declaration);

BackgroundSize.names = ['background-size'];
module.exports = BackgroundSize;